import React from "react";
import { motion } from "framer-motion";
import { TID } from "../lib/testIds";

const QUOTES = [
  {
    key: "k1",
    quote:
      "Ulties shipped our AI research agents in six weeks. The same effort took a previous vendor eight months — and theirs never reached production.",
    name: "Mara Selvaraj",
    role: "CTO · Atlas Capital",
    avatar:
      "https://images.unsplash.com/photo-1770894807442-108cc33c0a7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxwb3J0cmFpdCUyMGRhcmslMjBiYWNrZ3JvdW5kJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc4MTM2ODEyN3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "k2",
    quote:
      "They rebuilt our mobile and desktop apps from scratch and uncovered three critical security gaps in week one. Clear-eyed, calm engineers.",
    name: "Daniel Okafor",
    role: "VP Engineering · Lumen Health",
    avatar:
      "https://images.unsplash.com/photo-1765776830139-72b2184dae5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxwb3J0cmFpdCUyMGRhcmslMjBiYWNrZ3JvdW5kJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc4MTM2ODEyN3ww&ixlib=rb-4.1.0&q=85",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid={TID.testimonials.section}
      className="relative py-28 md:py-40 bg-surface border-y border-hairline overflow-hidden"
    >
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.04),transparent_55%)]" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="mb-16 md:mb-20">
          <span className="text-[11px] tracking-[0.28em] uppercase text-muted-x font-mono-x">
            ◇ Testimonials
          </span>
          <h2 className="mt-4 font-display text-5xl md:text-7xl font-medium tracking-tight leading-[0.95] max-w-4xl text-primary-x">
            Words from <em className="not-italic text-muted-x">the trenches.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
          {QUOTES.map((q, i) => (
            <motion.figure
              key={q.key}
              data-testid={TID.testimonials.item(q.key)}
              initial={{ y: 40, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="relative rounded-2xl border border-hairline bg-glass backdrop-blur-2xl p-8 md:p-12"
            >
              <div className="absolute top-8 right-8 font-display text-7xl leading-none" style={{ color: "var(--hairline-strong)" }}>”</div>
              <blockquote className="font-display text-2xl md:text-3xl font-medium leading-snug tracking-tight text-primary-x text-balance">
                {q.quote}
              </blockquote>
              <figcaption className="mt-10 flex items-center gap-4">
                <img
                  src={q.avatar}
                  alt={q.name}
                  className="h-12 w-12 rounded-full object-cover ring-1 ring-hairline-strong"
                  loading="lazy"
                />
                <div>
                  <div className="text-primary-x text-sm font-medium">{q.name}</div>
                  <div className="text-muted-x text-xs tracking-[0.18em] uppercase font-mono-x">
                    {q.role}
                  </div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
